// Darussalam B2B Wholesale — interactive JS
// Tag the body so theme-chrome overrides activate, then bind nav + FAQ icons.

document.body.classList.add('db-b2b-page');

(function () {
  'use strict';

  const root = document.querySelector('[data-darussalam-b2b]');
  if (!root) return;

  /* ───── Mobile nav toggle ───── */
  const toggle = root.querySelector('[data-db-nav-toggle]');
  const links = root.querySelector('[data-db-nav-links]');

  if (toggle && links) {
    toggle.addEventListener('click', () => {
      const open = links.classList.toggle('is-open');
      toggle.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    links.querySelectorAll('a').forEach((a) => {
      a.addEventListener('click', () => {
        links.classList.remove('is-open');
        toggle.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('click', (e) => {
      if (!toggle.contains(e.target) && !links.contains(e.target)) {
        links.classList.remove('is-open');
        toggle.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ───── Smooth scroll for in-page anchors ───── */
  root.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;
    const id = link.getAttribute('href').slice(1);
    if (!id) return;
    const target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    const nav = document.querySelector('.db-nav');
    const offset = nav ? nav.offsetHeight + 20 : 80;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  });

  /* ───── Active nav link on scroll ───── */
  const navLinks = root.querySelectorAll('.db-nav-links a[href^="#"]');
  const sections = Array.from(navLinks)
    .map((a) => document.getElementById(a.getAttribute('href').slice(1)))
    .filter(Boolean);

  if ('IntersectionObserver' in window && sections.length) {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            navLinks.forEach((a) => {
              a.classList.toggle(
                'is-active',
                a.getAttribute('href') === '#' + id
              );
            });
          }
        });
      },
      { rootMargin: '-40% 0px -50% 0px', threshold: 0 }
    );
    sections.forEach((s) => obs.observe(s));
  }

  /* ───── Single-FAQ-open behaviour ───── */
  const faqItems = root.querySelectorAll('.db-faq-item');
  faqItems.forEach((item) => {
    item.addEventListener('toggle', () => {
      if (item.open) {
        faqItems.forEach((other) => {
          if (other !== item) other.open = false;
        });
      }
    });
  });
})();
